import { Helmet } from "react-helmet"
import { texts } from "../../texts"

export const ProductHelmet = ({title}) => {
    return (
        <Helmet>
            <title>{title + texts.product.title}</title>
        </Helmet>
    )
}